<template>
    <div id="content_page_layout" :class="[isMobile? 'active': '', menuDrawable ? 'menu_drawable' : '']">
        <div id="background_image" />
        <header id="header_box" :class="[isMobile ? 'active' : '', augmentationRoute ? 'augment': '']">
            <v-btn v-if="!isMobile" fab dark class="header_menu_drawable_btn" @click="menuDrawable = !menuDrawable">
                <v-icon dark>
                    {{ menuDrawable ? 'fas fa-list-ul' : 'fas fa-ellipsis-v' }}
                </v-icon>
            </v-btn>
            <div id="header_title" :class="[isMobile ? 'active' : '']">
                <nav class="breadcumb" :class="[augmentationRoute ? 'augment' : '']">
                    <ul>
                        <li v-if="location === '/account'">
                            <a href="#/account">Profil</a>
                        </li>
                        <li v-if="location === '/contact'">
                            <a href="#/contact">Contact</a>
                        </li>
                        <li v-if="location === '/support'">
                            <a href="#/support">FAQ</a>
                        </li>
                        <li v-if="globalCond">
                            <a href="/#/experiences">Expériences</a>{{ $route.params.experienceToken ? '/': '' }}
                        </li>
                        <li v-if="experienceCond">
                            <a :href="'#/experiences/' + $route.params.experienceToken">
                                {{ !isPro ? "Mon Blinkl Stories" : experience.name === '' ? actionsExperience :
                                    experience.name }}
                            </a>
                            {{ $route.params.augmentationToken ? '/': '' }}
                        </li>
                        <li v-if="augmentationCond">
                            <a :href="'/#/experiences/' + $route.params.experienceToken + '/augmentations/'
                                + $route.params.augmentationToken">{{ augmentation.name }}</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
        <div id="main_box" class="scroll-y" :class="[isMobile ? 'active' : '', augmentationRoute ? 'augment' : '']">
            <slot name="main" />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'AppContainer',
        computed: {
            ...mapGetters('app', ['isPro', 'isMobile']),
            ...mapGetters('augmentations', ['experience']),
            ...mapGetters('actions', ['augmentation']),
            actionsExperience: function () {
                return this.$store.state.actions.experience.name;
            },
            location: function () {
                return this.$route.path;
            },
            augmentationRoute: function () {
                return this.location.startsWith('/experiences') && this.$route.params.experienceToken;
            },
            globalCond: function () {
                return (!this.isMobile && this.isPro && this.location.startsWith('/experiences')) ||
                    (this.isMobile && this.isPro && this.location.startsWith('/experiences') && !this.$route.params.experienceToken);
            },
            experienceCond: function () {
                return (!this.isMobile && this.location.startsWith('/experiences') && this.$route.params.experienceToken) ||
                    (this.isMobile && this.location.startsWith('/experiences') && this.$route.params.experienceToken && !this.$route.params.augmentationToken);
            },
            augmentationCond: function () {
                return this.location.startsWith('/experiences') && this.$route.params.experienceToken && this.$route.params.augmentationToken;
            },
            menuDrawable: {
                get () {
                    return this.$store.state.app.menuDrawable;
                },
                set (value) {
                    this.$store.commit('app/SET_MENU_DRAWABLE', value);
                }
            }
        }
    };
</script>

<style lang="scss" scoped>

    #content_page_layout {
        height: 100vh;
        width: calc(100vw - 75px);
        background-color: #E4E4E4;
        padding: 0;
        left: 75px;
        position: absolute;
        transition: all 0.3s ease-out;
    }

    #content_page_layout.active {
        width: 100% !important;
        left: 0 !important;
        transition: all 0.3s ease-out;
    }

    #content_page_layout.menu_drawable {
        width: calc(100vw - 220px);
        left: 220px;
        transition: all 0.3s ease-out;
    }

    #header_box {
        color: #169CEB;
        font-weight: 400;
        text-align: left;
        font-family: "Fira Sans", sans-serif;
        min-height: 75px;
        border-bottom: 1px solid #cfcfca;
        position: absolute;
        z-index: 1;
        width: 100%;
        background-color: #E4E4E4;
    }

    #header_box.active {
        z-index: 1;
        position: fixed;
        width: 100%;
        height: 60px;
    }

    #header_box.augment {
        background-color: rgba(255, 255, 255, 0.2);
        border-bottom: 1px solid white;
    }

    #header_title {
        display: inline-block;
        font-size: 20px;
        top: 50%;
        left: 90px;
        width: calc(100% - 130px);
        position: absolute;
        transform: translateY(-50%);
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    #header_title.active {
        left: 20px;
        width: calc(100vw - 95px);
    }

    #main_box {
        height: calc(100% - 75px);
        top: 75px;
        width: 100%;
        position: absolute;
        overflow-y: auto;
    }

    .header_menu_drawable_btn {
        width: 40px !important;
        height: 40px !important;
        top: 50%;
        left: 30px;
        position: absolute;
        transform: translateY(-50%);
        background-color: #169CEB !important;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.2) !important;
    }

    .header_menu_drawable_btn i {
        height: 22px;
        font-size: 20px !important;
        width: 20px;
    }

    .breadcumb {
        width: max-content;
        color: #169CEB !important;
    }

    .breadcumb.augment,
    .breadcumb.augment a {
        color: white !important;
    }

    .breadcumb ul {
        align-items: flex-start;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .breadcumb ul * {
        text-decoration: none;
    }

    .breadcumb ul li {
        align-items: center;
        display: flex;
        margin: 0;
    }

    .breadcumb ul li a {
        padding-left: 5px;
        padding-right: 5px;
    }

    .breadcumb li:first-child a {
        padding-left: 0;
    }

    .breadcumb ul li a:hover {
        color: #169CEB !important;
        transition: color 0.1s ease-in;
    }

    #background_image {
        height: 100vh;
        width: 100vw;
        filter: blur(8px);
        transform: scale(1.2);
        overflow: hidden;
        position: absolute;
    }
</style>
